<app-product-list [selectedCustomer]="selectedCustomer!"
                  [selectedProducts]="selectedProducts"
                  (cartUpdated) ="onCartUpdated($event)"
                  [products]="products">
</app-product-list>
